export default __webpack_public_path__ + "static/media/evandronascimento.b861ae7a.jpg";